module.exports = __webpack_public_path__ + "images/pdf-f567e5778ba29a113c8b944915ee3d05.svg";